import React from 'react';
import type { ResizeMethod } from '../../types/resize';
import { Maximize2, HardDrive } from 'lucide-react';

interface ResizeMethodSelectorProps {
  method: ResizeMethod | null;
  onChange: (method: ResizeMethod) => void;
}

export function ResizeMethodSelector({ method, onChange }: ResizeMethodSelectorProps) {
  return (
    <div className="space-y-3">
      <h3 className="text-xs font-bold uppercase tracking-wider text-slate-700 dark:text-slate-300">
        Select Resize Method
      </h3>
      <div className="grid grid-cols-2 gap-3">
        <button
          type="button"
          onClick={() => onChange('dimension')}
          className={`p-3 rounded-xl border text-left transition-all flex items-start gap-2.5 ${
            method === 'dimension'
              ? 'border-indigo-600 bg-indigo-50 dark:bg-indigo-950/70 text-indigo-900 dark:text-indigo-200 ring-2 ring-indigo-500/30'
              : 'border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 text-slate-800 dark:text-slate-200 hover:border-indigo-400'
          }`}
        >
          <Maximize2 className="w-4 h-4 text-indigo-500 mt-0.5 flex-shrink-0" />
          <div>
            <h4 className="font-bold text-xs">Dimension-Based</h4>
            <p className="text-[11px] text-slate-500 dark:text-slate-400 mt-0.5 leading-snug">
              Specify exact px dimensions
            </p>
          </div>
        </button>

        <button
          type="button"
          onClick={() => onChange('size')}
          className={`p-3 rounded-xl border text-left transition-all flex items-start gap-2.5 ${
            method === 'size'
              ? 'border-indigo-600 bg-indigo-50 dark:bg-indigo-950/70 text-indigo-900 dark:text-indigo-200 ring-2 ring-indigo-500/30'
              : 'border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 text-slate-800 dark:text-slate-200 hover:border-indigo-400'
          }`}
        >
          <HardDrive className="w-4 h-4 text-indigo-500 mt-0.5 flex-shrink-0" />
          <div>
            <h4 className="font-bold text-xs">Size-Based</h4>
            <p className="text-[11px] text-slate-500 dark:text-slate-400 mt-0.5 leading-snug">
              Optimize for target KB limit
            </p>
          </div>
        </button>
      </div>
    </div>
  );
}